// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Folder20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Folder20: FC<Folder20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M3.5 16a1.44 1.44 0 0 1-1.052-.448A1.44 1.44 0 0 1 2 14.5v-9c0-.412.15-.766.448-1.06.299-.293.65-.44 1.052-.44H8l2 2h6.5c.413 0 .766.147 1.06.44.293.294.44.647.44 1.06v7c0 .403-.147.754-.44 1.052A1.433 1.433 0 0 1 16.5 16h-13Zm0-1.5h13v-7H9.375l-2-2H3.5v9Z" />
        </svg>
    );
};

export default Folder20;
